import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core'

@Component({
	selector: 'app-banner-form',
	templateUrl: './banner-form.component.html',
	styleUrls: ['./banner-form.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class BannerFormComponent implements OnInit {
	@Input() title: string = ''
	@Input() invertColors: boolean = false
	@Input() description: string = ''
	@Input() text: string = ''
	@Input() disclaimer: string = ''
	@Input() img: string = ''
	@Input() alt_text: string = ''
	@Input() background_color: string = ''
	@Input() background_color_form: string = ''
	@Input() background_color_behind_form: string = ''

	constructor() {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['img'] && this.img) {
			this.preloadImage(this.img)
		}
	}

	private preloadImage(url: string) {
		const link = document.createElement('link')
		link.rel = 'preload'
		link.as = 'image'
		link.href = url
		document.head.appendChild(link)
	}
}
